import { SCROLL_TOP_PRECISION } from '../constants.js';

// NOTE: this check is key to preventing unnecessary scroll events
// by restricting the scroll precision, otherwise we'll lerp/scroll toward
// infinity and the browser will get needless scroll updates forever
export default function restrictScrollPrecision(current, dest) {
  const diff = current > dest ? current - dest : dest - current;
  if (diff < SCROLL_TOP_PRECISION) return current;
  return dest;
};